import apiClient from '@/services/axios'
import store from 'store'
import { normalizeApiError } from '@/services/normalizeError'

export async function google(id_token) {
  return apiClient
    .post('/auth/google', {
      id_token,
    })
    .then(response => {
      if (response) {
        const { token } = response.data
        if (token) {
          store.set('xToken', token)
        }
        return response.data
      }
      return false
    })
    .catch(err => { throw normalizeApiError(err) })
}

export async function login(email, password) {
  return apiClient
    .post('/auth/login', {
      email,
      password,
    })
    .then(response => {
      if (response) {
        const { token } = response.data
        if (token) {
          store.set('xToken', token)
        }
        return response.data
      }
      return false
    })
    .catch(err => { throw normalizeApiError(err) })
}

export async function register(email, password, name) {
  return apiClient
    .post('/auth/register', {
      email,
      password,
      name,
    })
    .then(response => {
      if (response) {
        const { xToken } = response.data
        if (xToken) {
          store.set('xToken', xToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => { throw normalizeApiError(err) })
}

export async function validateToken() {
  if (localStorage.xToken) {
    return apiClient
      .post('/auth/validate-token', { 'xToken': localStorage.xToken })
      .then(response => {
        return { isValidToken: true, ...response }
      })
      .catch(err => {
        console.log(err)
        return { isValidToken: false, ...err }
      })
  }
  return { isValidToken: false }
}

export async function logout() {
  store.remove('xToken')
}
